import {
  ApiCoreWrapper,
  ApolloWrapper,
  Auth0Wrapper,
  ConfigurationWrapper,
  EffectiveSearchParamsWrapper,
  EnclaveEmailMfaWrapper,
  EnclaveTokenStorageWrapper,
  KeychainWrapper,
  MaintenanceBannerWrapper,
  PagesWrapper,
  QueryClientWrapper,
  RouterWrapper,
  SnackbarWrapper,
  StylesWrapper,
  useKeychainSharedInstance,
  WelcomeWrapper,
} from "wrappers";

const App = () => {
  const [getKeychainSharedInstance, setKeychainSharedInstance] =
    useKeychainSharedInstance();
  return (
    <RouterWrapper>
      <ConfigurationWrapper>
        <StylesWrapper>
          <QueryClientWrapper>
            <Auth0Wrapper>
              <MaintenanceBannerWrapper>
                <EnclaveTokenStorageWrapper>
                  <ApiCoreWrapper>
                    <EnclaveEmailMfaWrapper>
                      <ApolloWrapper
                        getKeychainSharedInstance={getKeychainSharedInstance}
                      >
                        <SnackbarWrapper>
                          <KeychainWrapper
                            onKeychainInstanceUpdated={
                              setKeychainSharedInstance
                            }
                          >
                            <WelcomeWrapper>
                              <EffectiveSearchParamsWrapper>
                                <PagesWrapper />
                              </EffectiveSearchParamsWrapper>
                            </WelcomeWrapper>
                          </KeychainWrapper>
                        </SnackbarWrapper>
                      </ApolloWrapper>
                    </EnclaveEmailMfaWrapper>
                  </ApiCoreWrapper>
                </EnclaveTokenStorageWrapper>
              </MaintenanceBannerWrapper>
            </Auth0Wrapper>
          </QueryClientWrapper>
        </StylesWrapper>
      </ConfigurationWrapper>
    </RouterWrapper>
  );
};

export default App;
